import React from 'react';

interface TrimmerCaretProps {
    position: number | null;
}

export function TrimmerCaret({ position }: TrimmerCaretProps) {
    if (position === null) return null;

    return (
        <div
            className="absolute top-[1px] my-[3.5px] bottom-0 w-0.5 bg-white-100 z-[6] pointer-events-none transition-[left] duration-[250ms] ease-linear"
            style={{ left: `${position}px` }}
        />
    );
}
